import { render } from "./process-group-create.vue?vue&type=template&id=d1e2b916"
import script from "./process-group-create.vue?vue&type=script&lang=js"
export * from "./process-group-create.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__